var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosecIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6048_161765)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 13.5,
    rx: 12,
    ry: 11.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.067 10.995C18.1386 10.9259 18.1958 10.8431 18.2352 10.7517C18.2745 10.6602 18.2952 10.5618 18.2962 10.4622C18.2971 10.3626 18.2781 10.2638 18.2405 10.1716C18.2028 10.0794 18.1472 9.99568 18.0768 9.92523C18.0064 9.85478 17.9227 9.79905 17.8305 9.7613C17.7384 9.72354 17.6396 9.70452 17.54 9.70534C17.4404 9.70616 17.342 9.7268 17.2505 9.76606C17.159 9.80532 17.0762 9.86242 17.007 9.93402L14.001 12.939L10.996 9.93402C10.9273 9.86033 10.8445 9.80123 10.7525 9.76024C10.6605 9.71925 10.5612 9.69721 10.4605 9.69543C10.3598 9.69365 10.2598 9.71218 10.1664 9.7499C10.073 9.78762 9.98815 9.84376 9.91694 9.91498C9.84572 9.9862 9.78957 10.071 9.75185 10.1644C9.71413 10.2578 9.69561 10.3578 9.69738 10.4585C9.69916 10.5592 9.7212 10.6586 9.76219 10.7506C9.80319 10.8426 9.86229 10.9254 9.93597 10.994L12.939 14L9.93397 17.005C9.80149 17.1472 9.72937 17.3352 9.7328 17.5295C9.73623 17.7238 9.81494 17.9092 9.95235 18.0466C10.0898 18.1841 10.2752 18.2628 10.4695 18.2662C10.6638 18.2696 10.8518 18.1975 10.994 18.065L14.001 15.06L17.006 18.066C17.1481 18.1985 17.3362 18.2706 17.5305 18.2672C17.7248 18.2638 17.9102 18.1851 18.0476 18.0476C18.185 17.9102 18.2637 17.7248 18.2671 17.5305C18.2706 17.3362 18.1985 17.1482 18.066 17.006L15.063 14L18.067 10.995Z",
    fill: "#666666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6048_161765",
    x: 0,
    y: 0,
    width: 28,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6048_161765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6048_161765",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosecIcon);
export default __webpack_public_path__ + "static/media/closecIcon.9e3eba06830480d3f3c40cc73be3d4c5.svg";
export { ForwardRef as ReactComponent };